import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui";
import { CatalogosContablesHeader } from "./CatalogosContablesHeader";
import { SeccionCecos } from "./SeccionCecos";
import { SeccionCuentas } from "./SeccionCuentas";

/**
 * Página con dos tabs (CeCo · Cuentas). Cada sección consume su propio
 * suspense query (precargado por el loader) y su mutation hook.
 */
export function AdminCatalogosContablesPage() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <CatalogosContablesHeader />
      <Tabs defaultValue="ceco">
        <TabsList className="mb-4">
          <TabsTrigger value="ceco">Centros de costo</TabsTrigger>
          <TabsTrigger value="cuentas">Cuentas contables</TabsTrigger>
        </TabsList>
        <TabsContent value="ceco">
          <SeccionCecos />
        </TabsContent>
        <TabsContent value="cuentas">
          <SeccionCuentas />
        </TabsContent>
      </Tabs>
    </div>
  );
}
